<!-- eslint-disable max-len -->
<template>
    <header class="border-b border-gray-DFDFDF lg:border-none px-[20px] pt-[30px] pb-[11px] lg:pt-[48px] lg:pb-[52px] md:px-10 bg-white -mt-[6px] lg:h-[176.5px]">
        <div class="flex justify-between items-center mb-0 -mt-[2px] h-[24px]">
            <img src="../assets/images/Customize.svg" :alt="$t('CUSTOMIZE')" />
            <p class="text-[14px]">
                <button
                    v-if="returnUrl && !isLoading"
                    @click="showModal = true"
                    class="flex back-to-button-wrapper font-oceanside text-[14px] lg:text-[16px]"
                >
                    <svg
                        width="8"
                        height="11"
                        viewBox="0 0 8 14"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                        class="inline flex-none mr-2 mt-[7px]"
                    >
                        <path d="M0.199951 7.00003C0.199951 6.80003 0.299951 6.60003 0.399951 6.50003L6.49995 0.400026C6.79995 2.55108e-05 7.29995 2.55108e-05 7.59995 0.300026C7.89995 0.600026 7.89995 1.10003 7.59995 1.40003L1.99995 7.00003L7.59995 12.6C7.89995 12.9 7.89995 13.4 7.59995 13.7C7.29995 14 6.79995 14 6.49995 13.7L0.399951 7.50003C0.299951 7.40003 0.199951 7.20003 0.199951 7.00003Z"></path>
                    </svg>
                    <span class="flex-none">
                        {{$t('EXIT')}}
                    </span>
                </button>
            </p>
        </div>

        <h1 class="mb-[8px] leading-[22px] mt-[4px]">
            <img
                v-if="productType === 'product-sm10'"
                src="../assets/images/icons/logo-sm10.svg"
                :alt="productName"
            >
            <span class="font-semibold text-[26px] text-wrap">
                {{ productName }}
            </span>
        </h1>

        <h2 class="text-base font-sans flex w-full justify-between">
            <div class="leading-[17px]">
                <template v-if="hideTotalPricing">
                    {{ $t('FINAL_PRICE_WILL_BE_CALCULATED_IN_CART') }}
                </template>

                <template v-else-if="productPriceCurrent != null">
                    {{ $t('YOUR_PUTTERS') }}:&nbsp;
                    <span class="font-semibold">
                        {{relativePrice}}{{ productPriceCurrent }}
                    </span>
                </template>
                <span v-else>
                    &nbsp;
                </span>
            </div>
            <product-header-options-menu
                @summary="handleShowSummary"
                @share="openShareModal"
                @help="openHelpModal"
                @reset="handleResetToDefault"
            />
        </h2>
        <teleport to="#cz3" v-if="showModal">
            <base-modal-confirm
                @modalClose="showModal = false"
                @confirmAndExit="navigateBackToProduct"
                :show-modal="showModal"
                :modal-heading="$t('BACK_TO_PRODUCT')"
                :modal-copy="$t('SELECTIONS_LOST_COPY')"
                :cta-copy="$t('CONTINUE')"
            />
        </teleport>

        <share-modal
            @modalClose="showShareModal = false"
            :show-modal="showShareModal"
            :modal-image="shareModalImage"
        />

        <base-modal
            @modalClose="showHelpModal = false"
            :show-modal="showHelpModal"
            modal-position="center"
        >
            <template v-slot:closeButton>
                <close-button
                    @click="showHelpModal = false"
                    class="absolute top-[26px] right-4"
                    width="16"
                />
            </template>
            <template v-slot:content>
                <div class="mb-1 text-[16px] font-semibold">
                    {{ $t('NEED_HELP') }}
                </div>

                <div class="mb-[35px] leading-snug">
                    {{ $t('NEED_HELP_COPY') }}
                </div>

                <div class="mb-1 text-[16px] font-semibold">
                    {{ $t('CALL') }}
                </div>

                <div class="mb-2 leading-snug">
                    {{ $t('CALL_COPY_1') }}&nbsp;
                    <a :href="`tel:${ $t('TITLEIST_PHONE_NUMBER') }`"
                        :class="[
                            'text-red underline',
                            'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
                        ]"
                    >
                        {{ $t('TITLEIST_PHONE_NUMBER') }}
                    </a>
                </div>
                <div class="mb-2 leading-snug">
                    {{ $t('CALL_COPY_2') }}
                    <span class="uppercase">
                        {{ $t('TITLEIST_OPEN_HOURS') }}
                    </span>
                </div>

                <div class="w-full border border-gray-DFDFDF my-3" />

                <div class="mb-1 text-[16px] font-semibold capitalize">
                    {{ $t('EMAIL') }}
                </div>

                <div class="mb-2 leading-snugext-lg leading-snug">
                    {{ $t('EMAIL_COPY_1') }}
                    <a
                        :class="[
                            'text-red underline',
                            'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
                        ]"
                        :href="$t('EMAIL_URL')"
                        target="_blank"
                    >
                        {{ $t('EMAIL') }}
                    </a>
                    {{ $t('EMAIL_COPY_2') }}&nbsp;
                </div>
            </template>
        </base-modal>
    </header>
</template>

<style scoped>
    .back-to-button-wrapper:hover svg {
        transition: all 0.3s;
        transform: translateX(-3px);
        color: #E41837;
    }
    .back-to-button-wrapper:hover span {
        transition: all 0.3s;
        color: #E41837;
    }

</style>

<script>
    import allStores from '../stores/all';

    import BaseModal from './BaseModal.vue';
    import BaseModalConfirm from './BaseModalConfirm.vue';
    import CloseButton from './buttons/CloseButton.vue';
    import ProductHeaderOptionsMenu from './ProductHeaderOptionsMenu.vue';
    import ShareModal from './ShareModal.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseModal,
            BaseModalConfirm,
            CloseButton,
            ProductHeaderOptionsMenu,
            ShareModal,
        },

        data() {
            return {
                showModal: false,
                showShareModal: false,
                shareModalImage: '',
                showHelpModal: false,
            };
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            productName() {
                return this.customizerStore.productName;
            },

            hideTotalPricing() {
                return this.customizerStore.options.pricingOverride?.hideTotalPricing;
            },

            productNameParts() {
                return this.productName?.split('-') || [];
            },

            productPriceCurrent() {
                return this.customizerStore.currentPriceFormatted?.current;
            },

            returnUrl() {
                return this.customizerStore.options.backToUrl;
            },

            isLoading() {
                return this.appStore.isLoading;
            },

            productType() {
                return this.viewController?.blueprint?.custom?.['t-product-type'];
            },

            relativePrice() {
                if (this.customizerStore.options.pricingOverride?.hideTotalPricing) {
                    return this.$t('PLUS');
                }

                return '';
            },
        },

        methods: {
            setShowGroupOverlay(value) {
                this.appStore.setShowGroupOverlay(value);
            },

            setShouldShowSummary(value) {
                this.appStore.setShouldShowSummary(value);
            },

            handleShowSummary() {
                this.$emit('show-summary');
                this.setShouldShowSummary(true);
                this.setShowGroupOverlay(true);
            },

            openShareModal() {
                this.setShowGroupOverlay(false);
                this.takeSnapshot();
                this.showShareModal = true;
            },

            openHelpModal() {
                this.setShowGroupOverlay(false);
                this.showHelpModal = true;
            },

            takeSnapshot() {
                this.emitter.$emit('snapshot', {
                    controllerId: this.viewController.id,
                    view: 'Side',
                    done: (data) => {
                        this.shareModalImage = data;
                    },
                });
            },

            handleResetToDefault() {
                this.customizerStore.resetAll();
                this.customizerStore.removePanelFromErrorState('Main');
                this.appStore.resetCustomization();
            },

            navigateBackToProduct() {
                this.showModal = false;

                this.customizerStore.resetAll();
                this.customizerStore.removePanelFromErrorState('Main');

                this.appStore.resetCustomization();

                this.customizerStore.backTo(this.returnUrl);
            },
        },
    };
</script>
